import { useCallback, useEffect, useState } from "react";
import { sapi, errText } from "@/lib/strategy";
import { useStrategy } from "@/context/StrategyContext";

export function useRoundData(path, deps = []) {
  const { roundId } = useStrategy();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [locked, setLocked] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!roundId) return;
    setLoading(true); setError(""); setLocked(false);
    try {
      const { data } = await sapi.get(`/rounds/${roundId}/${path}`);
      setData(data);
    } catch (e) {
      if (e?.response?.status === 423) setLocked(true); else setError(errText(e));
    } finally { setLoading(false); }
  }, [roundId, path]);

  useEffect(() => { setData(null); load(); }, [load, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
  return { data, setData, error, locked, loading, reload: load, roundId };
}
